var React = require('react');

function Up (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 16L-1.42534e-07 12.7392L12 -5.24537e-07L24 12.7392L21 16L12 6.4L3 16Z","fill":"currentColor"}));
}

Up.defaultProps = {"viewBox":"0 0 24 17","fill":"none","style":{"color":"#39424A"}};

module.exports = Up;

Up.default = Up;
